import React from 'react';
import { useThemeContext } from './theme/ThemeContextProvider';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { RouterProvider } from 'react-router-dom';
import { CDNContent } from './services/cdn/CDNContent';
import { router } from './routing/routing';

export function App() {
  const { theme } = useThemeContext();

  return (
    <>
      <CDNContent />
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <RouterProvider router={router} />
      </ThemeProvider>
    </>
  );
}

export default App;
